import type ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { Observable, map } from "rxjs";
import { create } from "superstruct";
import { inject, singleton } from "tsyringe";

import NudgesEntity from "../../entities/NudgesEntity";
import { NudgesSchema } from "../../schemas/NudgesSchemas/NudgesSchema";
import { nudgesAuthApiClientToken } from "../../tokens";

export type NudgePayload = {
    nudgeId: string;
    page: string;
};

export type LastNudgesPayload = {
    page: string;
    locale: string;
};

@singleton()
class NudgesApiService {
    constructor(
        @inject(nudgesAuthApiClientToken)
        private readonly apiClient: ApiClientInterface
    ) {}

    public getLastNudgeWithoutView({
        locale,
        page,
    }: LastNudgesPayload): Observable<NudgesEntity> {
        return this.apiClient
            .get({
                url: "/getLastNudgeWithoutView",
                responseType: "json",
                queryParams: { page, locale },
            })
            .pipe(map((response) => create(response.body, NudgesSchema)));
    }

    addViewed({ nudgeId, page }: NudgePayload) {
        return this.apiClient.post({
            url: "/addView",
            body: JSON.stringify({
                nudgeId,
                page,
            }),
            contentType: "application/json",
            responseType: "json",
        });
    }

    addAction({ nudgeId, page }: NudgePayload) {
        return this.apiClient.post({
            url: "/addAction",
            body: JSON.stringify({
                nudgeId,
                page,
            }),
            contentType: "application/json",
            responseType: "json",
        });
    }
}

export default NudgesApiService;
